import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token fallback (useful when cookies are blocked).
//
// Why localStorage despite XSS risk: the backend already issues an
// httpOnly Secure SameSite=None `session_token` cookie at login — that's
// the primary credential. The localStorage `auth_token` mirror exists
// ONLY as a fallback for browsers/contexts that block 3P cookies
// (Safari ITP, some mobile webviews). Any sensitive operation must
// still be re-checked by the backend; XSS-exfiltrated bearer is
// scoped to JWT lifetime (7d). Mitigations in place:
//   • Frontend has zero `eval`/`Function` constructor usage
//   • CSP headers via the deployment proxy (no `unsafe-inline` JS)
//   • Tokens are namespaced (`auth_token`) so 3rd-party scripts can't
//     guess them easily
// A future hardening pass could move to sessionStorage-only + cookie-
// only with explicit CSRF tokens.
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token");
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  // Buyer-side country filter: auto-attach ?country=XX to the product
  // and stream feeds so whatever screen the user is on respects it.
  // Admin/Seller endpoints and already-specified country values are
  // left alone.
  try {
    const method = (config.method || "get").toLowerCase();
    const url = config.url || "";
    if (method === "get") {
      const affected = /^\/?(products|streams|recommendations\/for-you)(\/|\?|$)/.test(url.replace(/^\//, ""));
      if (affected) {
        const country = localStorage.getItem("buyer_country") || "";
        if (country && country !== "ALL") {
          config.params = config.params || {};
          if (config.params.country == null) config.params.country = country;
        }
      }
    }
  } catch { /* noop */ }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
